import { Link, NavLink, Outlet } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "../../../components/ui/breadcrumb";
import useVendorStore from "../../../store/vendor.store";

export default function VendorDetailsAdminPartial() {
  const menuList = [
    {
      name: "Overview",
      link: "overview",
    },
    {
      name: "Campaigns",
      link: "campaigns",
    },
    // {
    //   name: "Transactions",
    //   link: "transactions",
    // },
  ];

  const { data: vendorData } = useVendorStore();

  return (
    <div className="flex flex-col justify-start items-center bg-background p-8 w-full h-screen text-primary container">
      <div className="flex justify-between items-center px-5 w-full">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <Link to="/admin/vendors">
                <h1 className="font-semibold text-secondary text-xl">
                  Manage Vendors
                </h1>
              </Link>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-secondary" />
            <BreadcrumbItem>
              <h1 className="font-semibold text-primary text-xl">
                {vendorData?.name}
              </h1>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <div className="flex justify-between items-center border border-border rounded-lg w-fit overflow-hidden">
          <ul className="flex justify-between items-center w-full font-semibold">
            {menuList.map((menu) => (
              <NavLink
                to={menu.link}
                key={menu.link}
                className={({ isActive }) =>
                  `px-6 h-14 flex items-center justify-center border border-transparent text-secondary rounded-lg ${isActive ? "border border-white text-white" : ""}`
                }
              >
                {menu.name}
              </NavLink>
            ))}
          </ul>
        </div>
      </div>
      <Outlet />
    </div>
  );
}
